<template>
  <div class="uk-flex uk-flex-center">
    <div
        class="uk-width-4-5@m uk-width-2-3@l uk-article uk-card uk-card-body uk-card-default mbk_border_top_primary_5px mbk_large_box_shadow">
            <span v-if="show_spinner" id="status_spinner" class="uk-navbar-item"><div uk-spinner="ratio: 2"
                                                                                      class="uk-spinner uk-icon"><svg
                width="60" height="60" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" data-svg="spinner"><circle
                fill="none" stroke="#000" cx="15" cy="15" r="14"
                style="stroke-width: 0.5px;"></circle></svg></div>
            </span>
      <h4 :class="[error ? 'uk-text-danger':'', 'uk-text-center']">{{ this.status }}</h4>
<!--      <div class='uk-text-center'>-->
<!--        <a class="uk-text-bold" v-if="is_tinkoff" :href="tinkoff_receipt_path">Получить квитанцию &ndash;&gt;</a>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "VerificationSuccess",
  data() {
    return {
      interval: setInterval(this.check, 3000),
      status: this.$t('processing'),
      show_spinner: true,
      is_tinkoff: true,
      tinkoff_receipt_path: "",
      error: false,
    }
  },
  methods: {
    isClearAble(res_code) {
      switch (res_code) {
        case 0:
          return true;
        case 1:
          return false;
        case 2:
          return true;
        case 302:
          return false;
        default:
          return true
      }
    },
    check() {
      if (this.$route.query.hasOwnProperty("MNT_TRANSACTION_ID")) {
        this.$http.get("/moneta/check-transaction/", {
          params: {transaction: this.$route.query.MNT_TRANSACTION_ID}
        }).then(response => {
          if (this.isClearAble(response.data.res_code)) {
            clearInterval(this.interval);
            this.show_spinner = false;
          }
          this.status = response.data.res_text;
        }).catch(error => {
          this.show_spinner = false;
          this.status = error.response.data.message;
          this.error = true;
          clearInterval(this.interval);
        })
      } else if (this.$route.query.hasOwnProperty("TRANSACTION_ID")) {
        this.$http.get("/moneta/is-transaction-success/", {
          params: {transaction: this.$route.query.TRANSACTION_ID}
        }).then(response => {
          if (this.isClearAble(response.data.res_code)) {
            clearInterval(this.interval);
            this.status = 'Платеж успешно прошел'
            this.tinkoff_receipt_path = `https://online.molbulak.com:9445/tr/${this.$route.query.PAYMENT_ID}.pdf`
            this.is_tinkoff = true;
            this.show_spinner = false;
          } else {
            clearInterval(this.interval);
            this.show_spinner = false;
            this.status = this.status = response.data.message ? response.data.message : 'Произошла ошибка при проверке реквизитов, проверьте правильность ввода';
            this.error = true;
          }
        }).catch(error => {
          this.show_spinner = false;
          this.status = error.response.data.message;
          this.error = true;
          clearInterval(this.interval);
        })
      } else {
        clearInterval(this.interval);
        this.show_spinner = false;
        this.status = 'Платеж успешно прошел'
      }
    }
  }
}
</script>